<template>
  <section>
    <h2 class="title is-2">Resources</h2>
    <div class="field search">
      <p class="control">
        <input
          class='input'
          type='text'
          name='search'
          placeholder='search'
          v-model="query"
        />
      </p>
    </div>
    <ul v-if="!loading && files.length > 0">
      <FileResource v-for="file in files"
        :key="file.id"
        :id="file.id"
        :url="file.url"
        :title="file.title"
      />
    </ul>
    <p v-if="!loading && files.length === 0 && query === ''">No Resources</p>
    <p v-if="!loading && files.length === 0 && query !== ''">No Resources found matching <strong>{{ query }}</strong></p>
    <Loader v-if="loading" />
  </section>
</template>

<script>
import store from '../store'
import FileResource from './FileResource.vue'
import Loader from './Loader.vue'
import { byCreatedOn } from '../sorters.js'

export default {
  name: 'FilesResources',
  components: {
    FileResource,
    Loader,
  },
  mounted () {
    store.dispatch('fetchResources')
    store.dispatch('fetchVideos')
  },
  data () {
    return {
      query: '',
    }
  },
  computed: {
    files () {
      return store.state.resources.sort(byCreatedOn).filter(x => {
        return x.title.toUpperCase().includes(this.query.toUpperCase())
      })
    },
    loading () {
      return store.state.loadingResources
    },
  },
}
</script>



// WEBPACK FOOTER //
// FilesResources.vue?4c3d6cf2